export const UserIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_11803_56123)">
      <circle cx="10.5" cy="10" r="10" fill="#F6F6F6" />
    </g>
    <circle cx="10.5" cy="10" r="9.5" stroke="#D5D5D5" />
    <path
      d="M10.5013 9.99984C11.4221 9.99984 12.168 9.254 12.168 8.33317C12.168 7.41234 11.4221 6.6665 10.5013 6.6665C9.58047 6.6665 8.83464 7.41234 8.83464 8.33317C8.83464 9.254 9.58047 9.99984 10.5013 9.99984ZM10.5013 10.8332C9.3888 10.8332 7.16797 11.3915 7.16797 12.4998V13.3332H13.8346V12.4998C13.8346 11.3915 11.6138 10.8332 10.5013 10.8332Z"
      fill="#637281"
    />
    <defs>
      <filter
        id="filter0_i_11803_56123"
        x="-3.5"
        y="-4"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-4" dy="-4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_11803_56123"
        />
      </filter>
    </defs>
  </svg>
);
